import React, { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import { useDispatch, useSelector } from "react-redux";
import { clearToken, setToken } from "../../redux/Features/Token/TokenSlice";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.token.value);

  const [user, setUser] = useState("");
  const [tokenValue, setTokenValue] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [triggerUseEffect, setUseEffect] = useState(false);

  // const handleCallbackResponse = (response) => {
  //   console.log("Encoded JWT ID Token", response.credential);
  //   const userObj = jwt_decode(response.credential);
  //   console.log("userObj", userObj);
  //   setUser(userObj);
  //   // setTokenValue(userObj);
  //   setUseEffect(true);
  //   setIsLoggedIn(true);
  //   dispatch(setToken(userObj));
  //   // sessionStorage.setItem("userObj", JSON.stringify(userObj));
  // };

  const onLogoutClick = () => {
    setUser("");
    dispatch(clearToken());
    setIsLoggedIn(false);
    // setTokenValue("");
    // sessionStorage.removeItem("userObj");
    console.log("Logout CLick");
  };

  //   useEffect(() => {
  //     if (tokenValue !== "") {
  //       // let userInfo = JSON.parse(sessionStorage.getItem("user", user))
  //       let userDetails = JSON.parse(sessionStorage.getItem("userObj"));
  //       console.log("userDetails", userDetails);
  //       //   setTokenValue(userDetails);
  //       setUser(userDetails);
  //       setUseEffect(true);
  //       //   localStorage.setItem("user", user);
  //     }
  //   }, [triggerUseEffect, isLoggedIn]);

  // useEffect(() => {
  //   /* global google */
  //   google.accounts.id.initialize({
  //     client_id:
  //       "236229986659-hn03je9sn60l06ogbkpsot1s7mqk817p.apps.googleusercontent.com",
  //     callback: handleCallbackResponse,
  //   });
  //   google.accounts.id.renderButton(document.getElementById("signin_button"), {
  //     theme: "outline",
  //     size: "large",
  //   });
  //   // localStorage.setItem("user", userObj);
  // }, []);

  console.log("user", user);

  return (
    <main className="w-fit h-fit">
      {/* <script src="https://accounts.google.com/gsi/client" async defer></script> */}
      <div>Login</div>
      {user ? null : (
        <main>
          <div id="signin_button"></div>
        </main>
      )}
      {/* {isLogged && <div id="signin_button"></div>} */}
      {user && (
        <main>
          <img src={user.picture}></img>
          <div>{user.name}</div>
        </main>
      )}
      {user ? (
        <main>
          <div onClick={onLogoutClick}>Logout</div>
        </main>
      ) : null}
      token{JSON.stringify(token)}
      isLoggedIn{JSON.stringify(isLoggedIn)}
      {/* -tokenValue{JSON.stringify(tokenValue)} */}
      -user{JSON.stringify(user)}
      {/* {`user-------${JSON.stringify(user)}---------`}
      {`userDetails-------${JSON.stringify(userDetails)}--------`} */}
      {/* <div
        id="g_id_onload"
        data-client_id="236229986659-hn03je9sn60l06ogbkpsot1s7mqk817p.apps.googleusercontent.com"
        data-login_uri="https://your.domain/your_login_endpoint"
        // data-auto_prompt="false"
      ></div>
      <div>Hello</div>
      <div
        className="g_id_signin"
        data-type="standard"
        data-size="large"
        data-theme="outline"
        data-text="sign_in_with"
        data-shape="rectangular"
        data-logo_alignment="left"
      ></div> */}
    </main>
  );
};

export default Login;
